<template>
  <div>
    <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <!-- <v-col cols="1">
          <v-btn icon dark disabled="">
            <v-icon size="28px"> mdi-arrow-left-bold-box-outline </v-icon>
          </v-btn>
        </v-col>-->
        <v-col cols="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="dialog = true"
                disabled
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-file-plus-outline</v-icon>
                <span class="lable_class">Add</span>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="opendEditPopup()"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-pencil-box-multiple-outline</v-icon>
                <span class="lable_class">Edit</span>
              </v-btn>
            </template>
            <span>Edit Selected Type, Project, Vendor and Item</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled class="ml-7 header_btn">
                <v-icon size="28px">mdi-eye-outline</v-icon>
                <span class="lable_class">View</span>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled class="ml-7 header_btn">
                <v-icon size="28px">mdi-delete-outline</v-icon>
                <span class="lable_class">Delete</span>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>
        <v-col cols="3">
          <v-menu bottom offset-y :close-on-content-click="false" v-model="search_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small dark v-bind="attrs" v-on="on" class="ml-7 header_btn">
                <span class="lable_class">Seach</span>
                <v-badge overlap dot :value="search" color="error">
                  <v-icon size="28px">mdi-magnify</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile width="400">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                    dense
                    solo
                    clearable
                    aria-autocomplete="false"
                    autocomplete="off"
                    autofocus
                    v-on:keyup.enter="search_menu = false"
                    v-debounce:500="getSummary"
                    @click:clear="search = null; getSummary(false)"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card>
          </v-menu>
          <v-menu
            bottom
            v-model="filter_menu"
            :close-on-content-click="false"
            content-class="elevation-0"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on" class="ml-7 header_btn" size="22px">
                <span class="lable_class">Filter</span>
                <v-badge
                  :content="filtersCount"
                  :value="filtersCount"
                  color="error"
                  overlap
                  size="28px"
                >
                  <v-icon>mdi-filter-menu-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile max-width="380" class="mb-5 mr-5 mt-9">
              <v-list class="filter-section-border">
                <v-subheader style="height:32px" class="mt-2 mb-2">
                  <v-row dense>
                    <v-col cols="10"></v-col>
                    <v-col cols="2" class="text-right">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            class="error"
                            @click="resetFilter()"
                            icon
                            small
                          >
                            <v-icon size="20" class="white--text">mdi-filter-remove-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Reset</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-subheader>
                <v-subheader>
                  <v-row dense>
                    <v-col cols="4">
                      <v-autocomplete
                        dense
                        flat
                        :items="status"
                        outlined
                        label="Status"
                        hide-details
                        x-small
                        class="body-2"
                        placeholder=" "
                        v-model="pagination.filters.bank_status"
                      ></v-autocomplete>
                    </v-col>
                    <v-col>
                      <v-autocomplete
                        dense
                        flat
                        :items="bank_filter"
                        outlined
                        label="Bank"
                        hide-details
                        x-small
                        class="body-2"
                        placeholder="All"
                        clearable
                        v-model="pagination.filters.bank"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-subheader>

                <v-subheader>
                  <v-row dense>
                    <v-col cols="4">
                      <v-autocomplete
                        dense
                        flat
                        :items="filter_by_amount"
                        outlined
                        label="Amt Filter By"
                        hide-details
                        class="body-2"
                        placeholder="All"
                        v-model="pagination.filters.amt_filter_by"
                      ></v-autocomplete>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="exact_amount"
                        label="Exact Amt"
                        type="number"
                        hide-details
                        dense
                        outlined
                        clearable
                        placeholder=" "
                        v-debounce:500="getSummary"
                        @click:clear="exact_amount = ''; getSummary(false)"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-subheader>

                <v-subheader>
                  <v-row dense>
                    <v-col cols="6">
                      <v-text-field
                        v-model="amount_from"
                        label="Amt From"
                        hide-details
                        dense
                        outlined
                        clearable
                        placeholder=" "
                        v-debounce:500="getSummary"
                        @click:clear="amount_from = ''; getSummary(false)"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="amount_to"
                        label="Amt To"
                        hide-details
                        dense
                        outlined
                        clearable
                        placeholder=" "
                        v-debounce:500="getSummary"
                        @click:clear="amount_to = ''; getSummary(false)"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-subheader>
              </v-list>
              <v-card-title class="pa-0">
                <v-btn
                  fab
                  color="error"
                  x-small
                  absolute
                  @click="filter_menu = false"
                  class="custom-close-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
          </v-menu>
        </v-col>
        <v-col cols="1">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" class="header_btn">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon size="28px" v-bind="attrs" v-on="on">mdi-printer</v-icon>
                    <span class="lable_class">Export report</span>
                  </template>
                  <span>Export report</span>
                </v-tooltip>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="getSummaryExcel(true)">
                <v-list-item-title>
                  <v-icon size="30">mdi-file-excel</v-icon>Generate report as Excel
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="getSummaryPdf(true)">
                <v-list-item-title>
                  <v-icon size="30">mdi-file-pdf</v-icon>Generate report as PDF
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col class="1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                class="ml-7 header_btn"
                @click="openDocList(selectedRows[0])"
                :disabled="selectedRows.length != 1"
              >
                <v-badge
                  color="error"
                  :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''"
                  :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''"
                  overlap
                >
                  <v-icon size="28px">mdi-dresser-outline</v-icon>
                </v-badge>
                <span class="lable_class">DOX</span>
              </v-btn>
            </template>
            <span>Documents</span>
          </v-tooltip>
        </v-col>
        <v-col cols="4" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">
            Transaction
            <v-icon
              class="ml-2"
              size="30"
              style="color:#ffffff !important"
              @click="logout()"
            >mdi-logout</v-icon>
          </span>
        </v-col>
      </v-row>
    </div>
    <div class="fixed-top-bar2 d-flex align-center">
      <v-row>
        <v-col cols="12">
          <router-link :to="'/report/4'" v-slot="{ href, navigate }">
            <a :href="href" @click="navigate">Report</a>
          </router-link>
          <span>/</span>
          <router-link :to="'/report_expense/'+$route.params.bank_id" v-slot="{ href, navigate }">
            <a :href="href" @click="navigate">{{bank_name2}}</a>
          </router-link>
          <span>/</span>
          <span>{{vendor_name}}</span>
          <span class="ml-10" v-if="display_start_date && display_end_date">
            Date Range:
            <b>{{display_start_date}} - {{display_end_date}}</b>
          </span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
    <v-card tile style="background:none" flat>
      <v-card-text class="pa-0 mx-auto">
        <v-data-table
          :headers="headers"
          class="elevation-1 rounded-0 my-transaction-table fix-table-layout fix-table-header"
          item-key="user_id"
          :items="items.data"
          mobile-breakpoint="50"
          dense
          :items-per-page="pagination.itemsPerPage"
          hide-default-footer
          :options.sync="pagination"
          :page.sync="pagination.page"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-start" width="2%">
                <v-simple-checkbox
                  v-model="item.selected"
                  :ripple="false"
                  class="custom-simple-box"
                ></v-simple-checkbox>
              </td>
              <td width="7%" class="text-center">{{(item.bank)?item.bank.bank_code:''}}</td>
              <td width="6%" class="text-center">
                <a
                  href="javascript:void(0)"
                  @click="editRow(item)"
                  class="blue--text"
                >{{ getFormatedDate(item.trans_date) }}</a>
              </td>
              <td width="8%" class="text-right">
                <span
                  :class="{
                      'error--text': item.rev_amount < 0,
                      'primary--text': item.rev_amount > 0,
                    }"
                >${{ getAmountFormat(item.rev_amount) }}</span>
              </td>
              <td width="20%" class="pl-5">{{(item.project)?item.project.p_name:''}}</td>
              <td width="54%">
                <v-tooltip left max-width="400">
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                      class="d-inline-block"
                      style="word-break: break-all;"
                      v-html="highlightedDescription(item.description.substring(0,40))"
                    >
                      <span v-if="item.description.length > 40">..</span>
                    </span>
                  </template>
                  <span>{{ item.description }}</span>
                </v-tooltip>
              </td>
              <td width="3%">
                <v-icon v-if="item.split_from_id!=null">mdi-arrow-split-vertical</v-icon>
              </td>
            </tr>
          </template>

          <template v-slot:header.select_all>
            <v-simple-checkbox
              v-model="select_all_checkbox"
              @input="changeSelectAll()"
              color="white"
              :ripple="false"
              class="select-all-checkbox custom-simple-box"
            ></v-simple-checkbox>
          </template>

          <template v-slot:body.append>
            <tr class="grey lighten-1 fix-bottom-bar pr-3">
              <td colspan="5" width="100%" class="text-center">
                <span class="pr-5">
                  Cr:
                  <span class="green white--text">${{ getAmountFormat(total_credit) }}</span>
                </span>
                <span class="pr-5">
                  Dr:
                  <span class="red white--text">${{ getAmountFormat(total_debit) }}</span>
                </span>
                Bal.:
                <span
                  class="white--text"
                  :class="{
                    'red': total_balance < 0,
                    'green': total_balance >= 0,
                  }"
                >${{ getAmountFormat(total_balance) }}</span>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="v-data-footer custom-pagination fix-footer-bar">
          <v-row dense>
            <v-col cols="6" class="d-flex align-center justify-end">
              <span>Total Record: {{items.total}}</span>
              <div class="v-data-footer__select pl-5">
                Rows per page:
                <v-select
                  v-model="pagination.itemsPerPage"
                  :items="pagination_settings.perPageList"
                  dense
                  hide-details
                ></v-select>
              </div>
            </v-col>
            <v-col cols="6" class="d-flex align-center justify-start">
              <v-pagination
                class="d-flex align-center justify-start"
                v-model="pagination.page"
                :length="items.last_page"
                total-visible="10"
              ></v-pagination>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
    <SingleUpdate
      :single_update_tran="single_update_tran"
      :selected_item="selected_item"
      :project_of_selected_status="project_of_selected_status"
      @closePopup="single_update_tran = false"
      @updateValue="refreshTransactions"
    />
    <MultipleUpdate
      @deleteSelection="deleteSelection"
      :multi_update_tran="multi_update_tran"
      :selected_items="selectedRows"
      @closePopup="multi_update_tran = false"
      @updateValue="refreshTransactions"
    />
    <DocList />
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import { parseParams, getDateFilterValue, logout } from "../../plugins/helper";
import SingleUpdate from "../Transaction/SingleUpdate";
import MultipleUpdate from "../Transaction/MultipleUpdate";
import { mapState, mapMutations } from "vuex";
import moment from "moment";
import DocList from "../document/List";
export default {
  name: "UsersList",
  components: {
    SingleUpdate,
    MultipleUpdate,
    DocList
  },
  data() {
    return {
      loading: false,
      display_start_date: getDateFilterValue("display_start_date"),
      display_end_date: getDateFilterValue("display_end_date"),
      single_update_tran: false,
      selected_item: {},
      multi_update_tran: false,
      select_all_checkbox: false,
      items: {
        data: []
      },
      project_of_selected_status: [],
      filter_menu: false,
      total_balance: 0,
      total_credit: 0,
      total_debit: 0,
      project_name: "",
      customer_name: "",
      transaction_type_name: "",
      vendor_name: "",
      bank_name2: "",
      expence_filter_flag: this.$route.params.is_expence == "1" ? true : false,
      headers: [
        { value: "select_all", text: "", sortable: false, width: "2%" },
        {
          value: "B3.bank_code",
          text: "Bank",
          sortable: true,
          width: "7%",
          align: "center"
        },
        {
          value: "tbl_transaction.trans_date",
          text: "Date",
          sortable: true,
          width: "6%",
          align: "center"
        },
        {
          value: "tbl_transaction.amount",
          text: "Amount",
          sortable: true,
          width: "8%",
          align: "right",
          class: "pr-0"
        },
        {
          value: "P.p_name",
          text: "Project",
          sortable: true,
          width: "20%",
          class: "pl-6"
        },
        {
          value: "tbl_transaction.description",
          text: "Description",
          sortable: true,
          width: "54%",
          class: "pl-2"
        },
        {
          value: "",
          text: "",
          sortable: true,
          width: "3%",
          class: "pl-2"
        }
      ],
      search_menu: false,
      search: null,
      tran_start_date: false,
      disable_dates: null,
      tran_end_date: false,
      bank_filter: [],
      status: [
        { text: "All", value: "" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" }
      ],
      date_filter: [
        { text: "Today", value: "1" },
        { text: "Custom", value: "8" },
        { text: "Last 7 Days", value: "2" },
        { text: "Last 30 Days", value: "3" },
        { text: "Last 60 Days", value: "4" },
        { text: "Last 90 Days", value: "5" },
        { text: "This Year", value: "6" },
        { text: "Last Year", value: "7" }
      ],
      filter_by_amount: [
        { text: "All", value: "1" },
        { text: "Credit", value: "2" },
        { text: "Debit", value: "3" }
      ],
      exact_amount: "",
      amount_from: "",
      amount_to: "",
      pagination: {
        itemsPerPage: -1,
        sortBy: ["sort_by_trans_code"],
        page: 1,
        filters: {
          f_project: "",
          f_type: "",
          search_type: "",
          // f_project: this.$route.params.project_id,
          f_vendor: this.$route.params.vendor_id,
          // f_customer: this.$route.params.customer_id,
          bank_id: this.$route.params.bank_id,
          bank: "",
          f_project_status: "1",
          f_vendor_status: "1",
          bank_status: "1",
          transaction_type_filter: "1",
          filter_by: "4",
          tran_start_date: getDateFilterValue("start_date"),
          tran_end_date: getDateFilterValue("end_date"),
          date_filter: getDateFilterValue("date_filter"),
          amt_filter_by: "1",
          income_expence_flag: "2"
        }
      }
    };
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    selectedRows() {
      return this.items.data.filter(function(item) {
        return item.selected == true;
      });
    },
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.exact_amount = this.exact_amount;
      paginationData.amount_from = this.amount_from;
      paginationData.amount_to = this.amount_to;
      return paginationData;
    },
    filtersCount() {
      let count = 0;
      if (
        this.pagination.filters.tran_start_date &&
        this.pagination.filters.tran_end_date
      ) {
        count++;
      }
      if (this.pagination.filters.date_filter) {
        count++;
      }
      if (this.pagination.filters.bank) {
        count++;
      }
      if (this.exact_amount) {
        count++;
      }
      if (this.amount_from && this.amount_to) {
        count++;
      }
      if (count == 0) {
        return "D";
      } else {
        return count;
      }
    }
  },
  watch: {
    pagination: {
      handler: function() {
        this.getSummary(false);
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations("document", ["setModal", "setDocumentData"]),
    deleteSelection(remove_selection_flag) {
      this.items.data = this.items.data.map(item => {
        if (item.selected) {
          if (
            remove_selection_flag == "vendor" ||
            remove_selection_flag == "chart of account"
          ) {
            item.expance_details = null;
            item.vendor = null;
            item.vendor_id = null;
          } else if (remove_selection_flag == "project") {
            item.project = null;
            item.project_id = null;
          } else if (remove_selection_flag == "item") {
            item.item_id = null;
          } else if (remove_selection_flag == "type") {
            item.trans_type_id = null;
            item.type = null;
          } else if (remove_selection_flag == "invoice group") {
            item.invoice_group_id = null;
          }
        }
        return item;
      });
    },
    refreshTransactions() {
      this.single_update_tran = false;
      this.multi_update_tran = false;
      this.getSummary(false);
    },
    opendEditPopup() {
      this.multi_update_tran = true;
    },
    editRow(item) {
      this.selected_item = item;
      this.single_update_tran = true;
    },
    changeSelectAll() {
      if (this.select_all_checkbox) {
        this.items.data = this.items.data.map(function(item) {
          item.selected = true;
          return item;
        });
      } else {
        this.items.data = this.items.data.map(function(item) {
          item.selected = false;
          return item;
        });
      }
    },
    getFormatedDate2(field_name) {
      let date = "";
      let year = "";
      let month = "";
      let day = "";
      if (this.$route.params.start_date && this.$route.params.start_date) {
        if (field_name == "start_date") {
          [year, month, day] = this.$route.params.start_date.split("-");
        } else {
          [year, month, day] = this.$route.params.end_date.split("-");
        }
        date = `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
      }
      return date;
    },
    highlightedDescription(description) {
      if (description && this.search) {
        let string1 = description.toLowerCase();
        let searchStr = this.search;
        let string2 = searchStr.toLowerCase();
        var index = string1.indexOf(string2);
        if (index >= 0) {
          description =
            description.substring(0, index) +
            "<span class='yellow'>" +
            description.substring(index, index + this.search.length) +
            "</span>" +
            description.substring(index + this.search.length);
          return description;
        } else {
          return description;
        }
      } else {
        return description;
      }
    },
    getTransactionSelectors() {
      let _self = this;
      this.pageData.filters.expence_filter_flag = this.expence_filter_flag;
      let url = parseParams(this.pageData);
      axios
        .get("transactions_selectors?" + url + "&get_filter=true")
        .then(response => {
          if (response.data.status) {
            _self.bank_filter = response.data.data.banks2;

            if (_self.pagination.filters.bank) {
              let set_blank_bank = "yes";
              _self.bank_filter.map(item => {
                if (item.value == _self.pagination.filters.bank) {
                  set_blank_bank = "no";
                }
              });
              if (set_blank_bank == "yes") {
                _self.pagination.filters.bank = "";
              }
            }
          }
        })
        .catch(function() {});
    },
    setFocus(className) {
      document.querySelectorAll("." + className + " input")[0].focus();
    },
    resetFilter() {
      this.loading = true;
      this.pagination.filters.f_project = this.$route.params.project_id;
      this.pagination.filters.f_vendor = this.$route.params.vendor_id;
      this.pagination.filters.f_project_status = "1";
      this.pagination.filters.f_vendor_status = "1";
      this.pagination.filters.bank_status = "1";
      this.pagination.filters.amt_filter_by = "1";
      this.pagination.filters.bank = "";
      this.pagination.filters.transaction_type_filter = "1";
      this.pagination.filters.filter_by = "4";
      this.pagination.filters.income_expence_flag = "2";
      this.exact_amount = "";
      this.amount_from = "";
      this.amount_to = "";
      this.getSummary(false);
      this.loading = false;
    },

    parseDate(key) {
      if (key == "tran_start_date") {
        if (this.dateFormatted) {
          this.disable_dates = this.dateFormatted;
        } else {
          this.disable_dates = null;
        }
      }
      const [year, month, day] = this.dateFormatted.split("-");
      this.pagination.filters[key] = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },
    getFormatedDate(date) {
      return moment(date).format("MM/DD/YY");
    },
    getAmountFormat(value) {
      if (value) {
        value = value.toString();
        return value.replace("-", "");
      } else {
        return 0;
      }
    },
    getSummaryExcel() {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      let url = parseParams(this.pageData);
      url = url + "&itemsPerPage=-1";
      window.location.href =
        process.env.VUE_APP_BASEURL +
        "/generate_get_profit_loss_data_transaction_pdf?is_pdf=true&is_excel=true&is_type=expense&user_id=" +
        localStorage.getItem("user_id") +
        "&company_id=" +
        company_data.company_id +
        "&" +
        url;
    },
    getSummaryPdf() {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      let url = parseParams(this.pageData);
      url = url + "&itemsPerPage=-1";
      window.location.href =
        process.env.VUE_APP_BASEURL +
        "/generate_get_profit_loss_data_transaction_pdf?is_pdf=true&is_type=expense&user_id=" +
        localStorage.getItem("user_id") +
        "&company_id=" +
        company_data.company_id +
        "&" +
        url;
    },
    getSummary(isGenerateReport) {
      let _self = this;
      this.loading = true;
      this.pageData.filters.expence_filter_flag = this.expence_filter_flag;
      let url = parseParams(this.pageData);
      if (isGenerateReport) {
        url = url + "&itemsPerPage=-1";
      }
      axios
        .get("report_transaction?" + url)
        .then(response => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
          _self.total_balance = response.data.total_balance;
          _self.total_credit = response.data.total_credit;
          _self.total_debit = response.data.total_debit;
          _self.project_name = response.data.project_name;
          _self.customer_name = response.data.customer_name;
          _self.vendor_name = response.data.vendor_name;
          _self.bank_name2 = response.data.bank_name2;
          _self.transaction_type_name = response.data.transaction_type;
          _self.select_all_checkbox = false;
          _self.getTransactionSelectors();

          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    openDocList(item) {
      this.setDocumentData({ key: "doc_list_modal", value: true });
      this.setDocumentData({ key: "type", value: 1 });
      this.setDocumentData({ key: "o_id", value: item.trans_id });
      this.setDocumentData({ key: "item", value: item });
      this.setDocumentData({ key: "main_task_id", value: "0" });
      this.setDocumentData({ key: "child_task_id", value: "0" });
      this.setDocumentData({ key: "form_name", value: "Transaction" });
      this.setDocumentData({ key: "item_name", value: "" });
      this.setDocumentData({ key: "job_name", value: "" });
      this.setDocumentData({ key: "user_name", value: "" });
      this.setDocumentData({ key: "customer_name", value: "" });
      this.setDocumentData({ key: "doc_module", value: "TRANSACTION" });
      if (item.bank) {
        this.setDocumentData({ key: "bank_name", value: item.bank.bank_name });
      } else {
        this.setDocumentData({ key: "bank_name", value: "" });
      }
      if (item.project) {
        this.setDocumentData({
          key: "project_name",
          value: item.project.p_name
        });
      } else {
        this.setDocumentData({ key: "project_name", value: "" });
      }
      if (item.vendor) {
        this.setDocumentData({ key: "vendor_name", value: item.vendor.v_name });
      } else {
        this.setDocumentData({ key: "vendor_name", value: "" });
      }
      if (item.expence) {
        this.setDocumentData({
          key: "chart_of_account_name",
          value: item.expance_details.bank_name
        });
      } else {
        this.setDocumentData({ key: "chart_of_account_name", value: "" });
      }
    },
    getProjectByStatus() {
      let _self = this;
      this.loading = true;
      axios
        .get("get_project_by_status?status=all")
        .then(response => {
          if (response.data.status) {
            _self.project_of_selected_status = response.data.data;
          }
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    logout() {
      logout(this.$router);
    }
  },
  mounted() {
    localStorage.removeItem("is_report_from_dashboard");
    this.getProjectByStatus();
  }
};
</script>
<style>
</style>